import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import { Button, Form, FormItem, Input, Container, Aside, Header, Main,
Menu, MenuItem, Submenu, Dropdown, DropdownMenu, DropdownItem, Breadcrumb, 
BreadcrumbItem, MessageBox, Table, TableColumn, Select, Option, Switch, Tooltip,
Pagination, Tag, Dialog, Upload, Cascader, Tabs, TabPane, Row, Col, Card,Radio, 
RadioGroup, Tree, Popover, InputNumber, DatePicker, Badge} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Header)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Switch)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Tag)
Vue.use(Dialog)
Vue.use(Upload)
Vue.use(Cascader)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Tree)
Vue.use(Popover)
Vue.use(InputNumber)
Vue.use(DatePicker)
Vue.use(Badge)



// 将弹框提示组件挂载到 Vue 原型对象上 每个组件可通过 this.$message 调用弹框提示
// Message.offset = 100
// Vue.prototype.$message = Message

// 确认提示弹框
Vue.prototype.$confirm = MessageBox.confirm